import { fileKindService } from 'services/fileService/fileKindService';
import { getPdfPageCountFromSource } from 'services/fileService/pdfPageCountService';
import type { PdfUploadMetadataSnapshot } from './types';

export type { PdfUploadMetadataSnapshot } from './types';

async function detectPdfPageCountFromUpload<
  T extends PdfUploadMetadataSnapshot,
>(file: T): Promise<number | undefined> {
  if (!fileKindService.isPdf(file) || !(file.file instanceof File)) {
    return undefined;
  }

  return getPdfPageCountFromSource(file.file);
}

/** Apply local PDF page-count scan once at upload time (not imageConvertStatus). */
export async function enrichPdfUploadPageCounts<
  T extends PdfUploadMetadataSnapshot,
>(file: T): Promise<T> {
  if (!fileKindService.isPdf(file) || file.pdfPageCount !== undefined) {
    return file;
  }

  const pdfPageCount = await detectPdfPageCountFromUpload(file);
  if (pdfPageCount === undefined) {
    return file;
  }

  return { ...file, pdfPageCount };
}

export async function enrichPdfUploadPageCountsBatch<
  T extends PdfUploadMetadataSnapshot,
>(files: T[]): Promise<T[]> {
  return Promise.all(files.map(enrichPdfUploadPageCounts));
}
